import React from 'react';
import { useSelector } from 'react-redux';
import { getWarehousesLookups } from 'src/slices/warehousesLookups';
import { getWarehouses } from 'src/slices/warehouses';
import FormSelect from 'shared/forms/FormSelect';
import { FormMultiSelect } from 'shared/formControls';

const WarehousesDropdown = (props) => {

    const warehousesLookups = props.useFullWarehouseData ? useSelector(getWarehouses) : useSelector(getWarehousesLookups);
    const value = typeof props.value === 'object' ? props.value : warehousesLookups.find(x => x.id == props.value);

    return (
        props.isMultiSelect ?
            <FormMultiSelect
                data={warehousesLookups}
                textField={props.textField || "whse"}
                dataItemKey="id"
                {...props}
                value={value}
            />
            :
            <FormSelect
                data={warehousesLookups}
                textField="whse"
                dataItemKey="id"
                {...props}
                value={value}
            />
    );
};

export default WarehousesDropdown;